import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';
import { ChangeLogGoalsComponent } from './change-log-goals.component';

@NgModule({
  declarations: [ChangeLogGoalsComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogGoalsComponent],
})
export class ChangeLogGoalsModule {}
